import 'polyfills'
import { setDefaultOptions } from 'date-fns'
import React from 'react'
import { createRoot } from 'react-dom/client'

import 'stylesheets/fonts/inter.scss'
import * as Sentry from '@sentry/react'

setDefaultOptions({ firstWeekContainsDate: 4, weekStartsOn: 1 })
;(async () => {
  const [{ default: PublicAppRoot }, { default: PublicAppRouter }] =
    await Promise.all([
      import('../PublicAppRoot'),
      import('../PublicAppRouter'),
    ])

  const render = () => {
    const mountNode = document.querySelector('body > #root')

    if (mountNode) {
      const root = createRoot(mountNode, {
        // Callback called when React catches an error in an ErrorBoundary.
        onCaughtError: Sentry.reactErrorHandler(),
        // Callback called when React automatically recovers from errors.
        onRecoverableError: Sentry.reactErrorHandler(),
        // Callback called when an error is thrown and not caught by an ErrorBoundary.
        onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
          console.warn('Uncaught error', error, errorInfo.componentStack)
        }),
      })

      root.render(
        <PublicAppRoot>
          <PublicAppRouter />
        </PublicAppRoot>
      )
    }
  }

  ;['complete', 'interactive'].includes(document.readyState)
    ? render()
    : window.addEventListener('DOMContentLoaded', render)
})()
